export default __webpack_public_path__ + "iphone-screen-list-e595345fe4062a64502705884a52e33d.png";